export const text = '#000000';
export const hover = '#8A1313';
export const titletwo = `"Poppins", Euclid Square, Arial, Helvetica, freesans, sans-serif `
export const title = `"pp-fragment-serif-2", Euclid Square, Arial, Helvetica, freesans, sans-serif `